import * as types from './mutation-types'
import * as _ from "lodash";

export default {

    [types.SET_FILTERS]: (state, {filters}) => {
        state.filters = {}
        _.each(filters, function (filter) {
            if (filter && filter.value) {
                Vue.set(state.filters, filter.key, filter.value)
            }
        })
    },
    [types.RESET_MODELS]: (state) => {
        state.models = []
    },
    [types.SET_SEARCHENDED]: (state, data) => {
        state.searchEnded = data
    },
    [types.SET_MODELS]: (state, data) => {
        if(data.skip !== 0) {
            state.models = state.models.concat(data.models)
        }
        else {
            state.models = data.models
        }
    },
    [types.SHOW_MODEL]: (state) => {
        state.overlay = true
    },
    [types.HIDE_MODEL]: (state) => {
        state.overlay = false
    },
    [types.SET_FAVORITES]: (state, data) => {
        Vue.set(state.favorites, state.project, data)
    },
    [types.SET_APPLICATION_FAVORITES]: (state, data) => {
        Vue.set(state.applicationFavorites, data.id, data.models)
    },
    [types.SET_FAVORITES_IDS]: (state, data) => {
        let storage = localStorage.getItem('favorites_' + state.project);
        let favoritesIds = storage ? JSON.parse(storage) : []
        Vue.set(state.favoritesIds, state.project, favoritesIds)
    },

    [types.SET_APPLICATION]: (state, application) => {
        state.application =  application
        state.applicationId =  application.id
    },

    [types.SET_NOOF_HEARTS]: (state) => {
        _.each(state.application.roles, function(role) {
            let hearts = _.filter(role.models, { 'favorite': '1'});
            Vue.set(role, 'hearts', hearts.length)
        })
    },

    [types.SET_HEART]: (state, data) => {
        let node = state.application.roles[data.proposalId].models[data.model_id]
        Vue.set(node, 'favorite', data.value+"")
        if(state.applicationFavorites && state.applicationFavorites.hasOwnProperty(data.proposalId) && data.value === 0){
            let node = state.applicationFavorites[data.proposalId]
            let index = _.findKey(node, {'ID_Model': data.model_id})

           Vue.delete(node,index)
        }
    },

    [types.SET_PROPOSAL]: (state, proposal) => {
        state.proposal = proposal
    },
    [types.SET_MODE]: (state, mode) => {
        state.list = mode
    },
    [types.SET_PROJECT]: (state, project) => {
        state.project = project
        state.propasalId = project

    },
    [types.SET_CONFIRM_DELETE_FAVORITE]: (state, value) => {
        state.confirmDeleteFavorite = value
    },
    [types.SHOW_CONFIRM_DELETE_FAVORITE]: (state, value) => {
        state.showConfirmDeleteFavorite = value
    },
    [types.SET_DELETE_FAVORITE_ID]: (state, value) => {
        state.deleteFavoriteId = value
    },
    [types.FORCE_HIDE_PREVIEW]: (state) => {
        state.forceHidePreview = true
        setTimeout(function () {
            state.forceHidePreview = false
        }, 400)
    },
    [types.FORCE_RELOAD_FAVORITES]: (state) => {
        state.forceReloadFavorites = true
        setTimeout(function () {
            state.forceReloadFavorites = false
        }, 400)
    },
    [types.SET_APPLICATION_ID]: (state, id) => {
        state.applicationId = id
    },
    [types.SET_PROPOSAL_ID]: (state, id) => {
        state.proposalId = id
    },

}
